import React, { MouseEvent, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

interface AudioButtonProps {
  word: string;
  size?: number;
}

const AudioButton: React.FC<AudioButtonProps> = ({ word, size = 32 }) => {
  const theme = useTheme();
  const [playing, setPlaying] = useState(false);

  const speak = (e: MouseEvent) => {
    e.stopPropagation();
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(word);
    u.lang = 'en-US';
    u.rate = 0.9;
    u.onend = () => setPlaying(false);
    u.onerror = () => setPlaying(false);
    setPlaying(true);
    window.speechSynthesis.speak(u);
  };

  const idleBg =
    theme.palette.mode === 'light'
      ? 'rgba(59, 44, 147, 0.10)'
      : 'rgba(155, 124, 255, 0.18)';

  return (
    <Box
      component={'button'}
      onClick={speak}
      title={`Вимова: ${word}`}
      sx={{
        alignItems: 'center',
        bgcolor: playing ? 'primary.main' : idleBg,
        border: 'none',
        borderRadius: '50%',
        color: playing ? 'common.white' : 'primary.main',
        cursor: 'pointer',
        display: 'inline-flex',
        flex: 'none',
        height: size,
        justifyContent: 'center',
        p: 0,
        transition: 'all .15s ease',
        width: size,
        '&:hover': { opacity: 0.85 },
      }}
    >
      <VolumeUpIcon sx={{ fontSize: size >= 32 ? 20 : 18 }} />
    </Box>
  );
};

export default AudioButton;
